import type { Account, AccountCountry } from "modules/bank-accounts";
import type { NotificationSettings } from "../../../models/NotificationSettings";
import type {
  B4BProvider,
  BankingCirceProvider,
  CashManagementProvider,
  ClearJunctionProvider,
} from "./Provider";

export interface CashManagementProviderAccount {
  cashManagementProvider?: CashManagementProvider;
  settlementEnabled: boolean;
  additionalConfiguration?:
    | BankingCirceProvider
    | ClearJunctionProvider
    | B4BProvider;
}

export interface CashManagementAccount extends Account {
  cashManagementProviderAccount: CashManagementProviderAccount;
  hasPayments: boolean;
}

export interface SettlementScheduleConfig {
  threshold: number;
  executeAt: string;
  enabled: boolean;
  schedules: [];
}

export type { AccountCountry };

export interface CashManagementNotificationSettings
  extends NotificationSettings {}

export const PROPERTY_SANDBOX_SETTLEMENT_BATCHES = "sandbox.settlementBatches";
export const PROPERTY_PRODUCTION_SETTLEMENT_BATCHES =
  "production.settlementBatches";
export const PROPERTY_SANDBOX_ACCOUNT_BALANCE =
  "sandbox.providersAccountBalance";
export const PROPERTY_PRODUCTION_ACCOUNT_BALANCE =
  "production.providersAccountBalance";

export const PROPERTY_PRODUCTION_SETTLEMENT_BALANCE =
  "production.settlementBalance";

export const PROPERTY_SANDBOX_SETTLEMENT_BALANCE = "sandbox.settlementBalance";

export const PROPERTY_PRODUCTION_SETTLEMENT_SCHEDULE_CONFIG =
  "production.settlementScheduleConfig";

export const PROPERTY_SANDBOX_SETTLEMENT_SCHEDULE_CONFIG =
  "sandbox.settlementScheduleConfig";
